import PreloaderImg from '../../assets/img/preloader.gif';

const Preloader= () => {
return(
    <div className='login-page-body-container coursel-1'>    
   <img alt='PreLoader' style={{position:"absolute" ,left:"45%" ,top:"40%",width:"200px"}} src={PreloaderImg}></img>
</div>
)
}
export default Preloader;